import { Component } from '@verndale/core';
import Dropdown from '../../components/dropdown';

import { keyCode } from '../../helpers';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      dropdown: this.el.querySelector('.lodging-detail__dropdown'),
      tabs: [...this.el.querySelectorAll('.lodging-detail__tabs button')],
      panels: [...this.el.querySelectorAll('.lodging-detail__section')]
    };

    this.dropdown = new Dropdown(this.dom.dropdown);
  }

  addListeners() {
    this.dom.tabs.forEach(tab => {
      tab.addEventListener('click', this.handleSelectTab.bind(this));
      tab.addEventListener('keydown', this.keydownEventListener.bind(this));
      tab.addEventListener('keyup', this.keyupEventListener.bind(this));
    });

    this.dropdown.on('option', this.handleSelectOption.bind(this));
  }

  keydownEventListener(e) {
    const key = e.keyCode;

    switch (key) {
      case keyCode.END:
        e.preventDefault();
        this.dom.tabs[this.dom.tabs.length - 1].focus();
        break;
      case keyCode.HOME:
        e.preventDefault();
        this.dom.tabs[0].focus();
        break;
    }
  }

  // Handle keyup on tabs
  keyupEventListener(e) {
    const key = e.keyCode;

    switch (key) {
      case keyCode.LEFT:
        if (e.target.previousElementSibling) {
          e.target.previousElementSibling.focus();
        } else {
          this.dom.tabs[this.dom.tabs.length - 1].focus();
        }
        break;
      case keyCode.RIGHT:
        if (e.target.nextElementSibling) {
          e.target.nextElementSibling.focus();
        } else {
          this.dom.tabs[0].focus();
        }
        break;
      case keyCode.RETURN:
      case keyCode.SPACE:
        this.handleSelectTab(e);
        break;
    }
  }

  handleSelectTab(e) {
    e.preventDefault();

    this.dom.tabs.forEach(tab =>
      tab.setAttribute('aria-selected', tab.id === e.target.id)
    );
    this.dom.panels.forEach(panel => {
      if (panel.id === e.target.getAttribute('aria-controls')) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', 'hidden');
      }
    });

    this.dom.dropdown.value = e.target.getAttribute('aria-controls');
    this.dropdown.update();

    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    });
  }

  handleSelectOption(e) {
    e.preventDefault();

    this.dom.tabs.forEach(tab =>
      tab.setAttribute(
        'aria-selected',
        tab.getAttribute('aria-controls') === e.target.value
      )
    );
    this.dom.panels.forEach(panel => {
      if (panel.id === e.target.value) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', 'hidden');
      }
    });

    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    });
  }
}

export default Module;
